import {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import ExpandLessIcon from "../icons/ExpandLessIcon/ExpandLessIcon";
import ExpandMoreIcon from "../icons/ExpandMoreIcon";
import FilterOffLineIcon from "../icons/FilterOffLineIcon";

import theme from "../../style/theme";
import {SqaureCheckBox} from "../checkbox/SquareCheckBox";
import FilterLineIcon from "../icons/FilterLineIcon";
import {handleClickOutside, useClickOutside} from "../../utils/click/handle-click";

interface Props {
    onClickFilterMultiSelectItem: (value: string) => void;
    values: string[];
    candidateMap: { [key: string]: string };
}

export const ClientFilterMultiSelect2: React.FC<Props> = (
    {
        values,
        onClickFilterMultiSelectItem,
        candidateMap,
    }
) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleClickBox = () => {
        setOpen(!open);
    };

    useClickOutside(ref, () => setOpen(false));

    return (
        <div ref={ref}>
            <SelectedItem values={values} onClick={handleClickBox} open={open}>
                <LeftSelectedItemIconWrapper>
                    {values.length > 0 ? <FilterLineIcon/> : <FilterOffLineIcon/>}
                </LeftSelectedItemIconWrapper>
                <SelectedItemLabel values={values}>
                    고객사
                </SelectedItemLabel>
                <RightSelectedItemIconWrapper>
                    {open ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                </RightSelectedItemIconWrapper>
            </SelectedItem>
            {open && (
                <MenuItemList>
                    {Object.keys(candidateMap).map((candidate) => {
                        const isSelected = values.includes(candidate);
                        return (
                            <MenuItem
                                key={candidate}
                                selected={isSelected}
                                onClick={() => onClickFilterMultiSelectItem(candidate)}
                            >
                                <LeftMenuItemIconWrapper>
                                    <SqaureCheckBox
                                        checked={isSelected}
                                        fill={isSelected ? "#FCCA00" : undefined}
                                    />
                                </LeftMenuItemIconWrapper>
                                <MenuItemLabel>{candidateMap[candidate]}</MenuItemLabel>
                            </MenuItem>
                        );
                    })}
                </MenuItemList>
            )}
        </div>
    );
};

interface SelectedItemProps {
    values: string[];
    open: boolean;
}

const SelectedItem = styled.div<SelectedItemProps>`
  width: 121px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  border: ${(props) =>
          props.values.length > 0 || props.open ? "1px solid #FCCA00" : "1px solid #bec3cb"};
  background-color: ${(props) =>
          props.values.length > 0 || props.open ? "#FFFCF2" : "#ffffff"};
  
  cursor: pointer;

  &:hover {
    background-color: #f5f6f9;
  }
`;

const LeftSelectedItemIconWrapper = styled.div`
  width: 36px;
  height: 40px;
  box-sizing: border-box;
  padding: 12px 8px 12px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface SelectedItemLabelProps {
    values: string[];
}

const SelectedItemLabel = styled.div<SelectedItemLabelProps>`
  width: 121px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.values.length > 0 ? "#8B6123" : "#3F444E")};
  display: flex;
  align-items: center;
`;

const RightSelectedItemIconWrapper = styled.div`
  width: 36px;
  height: 24px;
  box-sizing: border-box;
  padding: 0 12px 0 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #e0e3e9;
`;

const MenuItemList = styled.div`
  width: 190px;
  margin: 8px 0 8px -66px;
  padding: 6.5px 0;
  position: absolute;
  background-color: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
  border: solid 1px #bec3cb;
  z-index: 500;
  max-height: max(calc(100vh - 400px), 250px);
  overflow-y: auto;
  overflow-x: hidden;

  /* 스크롤 바 스타일 */

  &::-webkit-scrollbar {
    width: 5px;
    background-color: #ffffff;
  }

  /* 스크롤바 색상 */

  &::-webkit-scrollbar-thumb {
    background-color: #1c2026;
    border-radius: 10px;
  }

  /* 스크롤바가 마우스 오버될 때 색상 */

  &::-webkit-scrollbar-thumb:hover {
    background-color: #bfbfbf;
  }
`;

const MenuItem = styled.div<{
    selected: boolean;
}>`
  width: 190px;
  height: 36px;
  display: flex;
  color: ${theme.palette.primitives.gray700};
  align-items: center;
  background-color: ${(props) =>
          props.selected ? theme.palette.primitives.yellow50 : "#ffffff"};
  
  cursor: pointer;

  &:hover {
    background-color: #f5f6f9;
  }

  font-size: 14px;
  font-weight: 500;
`;

const LeftMenuItemIconWrapper = styled.div`
  width: 42px;
  height: 36px;
  box-sizing: border-box;
  padding: 9px 8px 9px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MenuItemLabel = styled.div`
  width: calc(100% - 42px);
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.palette.primitives.gray700};
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  max-lines: 1;
  white-space: nowrap;
  overflow: hidden;
`;
